module.exports = __webpack_public_path__ + "img/icon-menu-news-situ2.b0ece515.png";